import { logError, logOperationalEvent, logWarn } from 'saddlebag-logger';

import type { Logger as TranslationsLogger } from '@web-platform/shared-travel-tools-types/src/translation-service';

const NAMESPACE = 'travel-tools';

type LogFields = Record<string, string | number>;

const wrapError = (msg: string, error?: Error | unknown) => {
  if (error instanceof Error) return error;
  return new Error(msg);
};

const sanitiseFields = (fields: LogFields | undefined): LogFields => {
  const result: LogFields = {};
  if (!fields) return result;
  Object.keys(fields).forEach((key) => {
    const value = fields[key];
    if (typeof value === 'string' || typeof value === 'number') {
      result[key] = value;
    }
  });
  return result;
};

export const logger = {
  event: (eventName: string, fields?: LogFields) => {
    logOperationalEvent({ ...sanitiseFields(fields), component: NAMESPACE, eventName });
  },
  warn: (message: string, fields?: LogFields) => {
    logWarn({ ...sanitiseFields(fields), component: NAMESPACE, message });
  },
  error: (message: string, fields?: LogFields, error?: Error | unknown) => {
    logError(wrapError(message, error), {
      ...sanitiseFields(fields),
      component: NAMESPACE,
      message,
    });
  },
} satisfies TranslationsLogger & {
  event: (eventName: string, fields?: LogFields) => void;
  error: (message: string, fields?: LogFields, error?: Error | unknown) => void;
};
